import { IInvoiceSidebarProps } from "components/InvoiceSidebar/InvoiceSidebar"
import { createStore, createEvent } from "effector"
const show = createEvent<IInvoiceSidebarProps>()
const hide = createEvent<IInvoiceSidebarProps>()
const clear = createEvent()

const list = createStore<IInvoiceSidebarProps[]>([])

list.on(show,
    (state: IInvoiceSidebarProps[], props: IInvoiceSidebarProps) => {
        return [...state, props]
    }
)

list.on(hide,
    (state: IInvoiceSidebarProps[], props: IInvoiceSidebarProps) => {
        return state.filter(p => p !== props)
    }
)

list.on(clear,
    () => []
)

export default {
    show,
    hide,
    clear,
    list,
}
